import schemas from 'src/modules/shared/yup/yupImporterSchemas';
import { i18n } from 'src/i18n';import foodOperatorEnumerators from 'src/modules/foodOperator/foodOperatorEnumerators';

export default [
  {
    name: 'name',
    label: i18n('entities.foodOperator.fields.name'),
    schema: schemas.string(
      i18n('entities.foodOperator.fields.name'),
      {
        "required": true
      },
    ),
  },
  {
    name: 'address',
    label: i18n('entities.foodOperator.fields.address'),
    schema: schemas.string(
      i18n('entities.foodOperator.fields.address'),
      {
        "required": true
      },
    ),
  },
  {
    name: 'country',
    label: i18n('entities.foodOperator.fields.country'),
    schema: schemas.enumerator(
      i18n('entities.foodOperator.fields.country'),
      {
        "required": true,
        "options": foodOperatorEnumerators.country
      },
    ),
  },
  {
    name: 'operatorType',
    label: i18n('entities.foodOperator.fields.operatorType'),
    schema: schemas.enumerator(
      i18n('entities.foodOperator.fields.operatorType'),
      {
        "required": true,
        "options": foodOperatorEnumerators.operatorType
      },
    ),
  },
];